import CrudPage from "@/components/admin/CrudPage";
import { Badge } from "@/components/ui/badge";
import { tanggal } from "@/lib/format";

const PRIO = { urgent: "bg-red-100 text-red-800", penting: "bg-[#f6ebd0] text-[#8a6d14]", normal: "bg-emerald-100 text-emerald-800" };

const fields = [
  { name: "title", label: "Judul", required: true, full: true },
  { name: "priority", label: "Prioritas", type: "select", options: [{ value: "normal", label: "Normal" }, { value: "penting", label: "Penting" }, { value: "urgent", label: "Urgent" }] },
  { name: "active", label: "Tampilkan di Website", type: "switch" },
  { name: "content", label: "Isi Pengumuman", type: "textarea", required: true },
];

const columns = [
  { key: "created_at", label: "Dibuat", render: (a) => tanggal(a.created_at?.slice(0, 10)) },
  { key: "title", label: "Judul", className: "font-medium" },
  { key: "priority", label: "Prioritas", render: (a) => <Badge className={`${PRIO[a.priority]} capitalize`}>{a.priority}</Badge> },
  { key: "active", label: "Status", render: (a) => <Badge variant={a.active ? "default" : "outline"} className={a.active ? "bg-emerald-800" : ""}>{a.active ? "Aktif" : "Nonaktif"}</Badge> },
];

export default function Pengumuman() {
  return (
    <CrudPage
      title="Pengumuman"
      subtitle="Papan pengumuman digital masjid"
      endpoint="announcements"
      prefix="admin-announcement"
      itemLabel="Pengumuman"
      fields={fields}
      columns={columns}
      defaults={{ title: "", priority: "normal", active: true, content: "" }}
      searchKeys={["title", "content", "priority"]}
    />
  );
}
